/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { BrandingsDestroyPathParams, BrandingsDestroyResponse } from '../types/BrandingsDestroy'

/**
 * DELETE /brandings/:branding
 * @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::destroy
 */
export async function brandingsDestroy(
	branding: BrandingsDestroyPathParams['branding'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<BrandingsDestroyResponse>> {
	return axiosInstance.delete(`/brandings/${branding}`, config)
}
